module.exports = __webpack_public_path__ + "static/ibi-group-logo-88df367c2cf2ea4d594c9d651b32a66a.jpg";